module.exports = __webpack_public_path__ + "static/img/pic_time@2x.d7263759.png";